import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import SupplierData from "../../components/Suppliers/SupplierList";

const Suppliers =() => {
    return(
      <>
     {/* <Breadcrumb /> */}
       <SupplierData/>
       </>
       );
};
export default Suppliers;